import { RawShaderMaterial, Vector3 } from 'three';

import { vert } from './vertex';
import { frag } from './fragment';
import { appMixin } from '../../../utils/appMixin';

export class TextMaterial extends appMixin(RawShaderMaterial) {
  /**
   *
   * @param {import("three").RawShaderMaterialParameters} options
   */
  constructor(app, options = {}) {
    if (options.isTexture)
      options = {
        uniforms: {
          ...app.uniforms,
          uMap: { value: null },
          uColor: { value: null },
        },
      };

    options.vertexShader = vert;
    options.fragmentShader = frag;

    super(app, options);
  }
}
